module.exports = __webpack_public_path__ + "static/media/superai_text_white_lg.496e3a0e.png";